import { ITooltipSchema } from '../../repositories/price-estimator/entities/onboardings/TooltipSchema';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EActionTypes {
  SetOnbordingData = 'onbording/set_onbording_data',
}

export const setOnbordingData = actionGenerator<EActionTypes.SetOnbordingData, ITooltipSchema[]>(
  EActionTypes.SetOnbordingData,
);

export type TOnbordingActions = ReturnType<typeof setOnbordingData>;
